export default __webpack_public_path__ + "static/lock@2x-a0bd3cc4a40b09ebc4c26c42c8a6f797.png";